import React, { useEffect } from 'react'
import Header from './Header'
import { Link } from 'react-router-dom'

function Resources() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
  return (
    <div>
      <>
        {/*[if lt IE 7]>      <html class="no-js lt-ie9 lt-ie8 lt-ie7" lang=""> <![endif]*/}
        {/*[if IE 7]>         <html class="no-js lt-ie9 lt-ie8" lang=""> <![endif]*/}
        {/*[if IE 8]>         <html class="no-js lt-ie9" lang=""> <![endif]*/}
        {/*[if gt IE 8]><!*/}
        {/*<![endif]*/}
        {/* Mirrored from html.dynamiclayers.net/te/logisko/services-logistic.html by HTTrack Website Copier/3.x [XR&CO'2014], Thu, 05 Dec 2024 18:04:19 GMT */}
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="description"
          content="Safe and Reliable Transportation  Transportation and Logistics "
        />
        <meta name="author" content="ThemeEaster" />
        <title>
          Safe and Reliable Transportation | Transportation and Logistics Company
        </title>
        <link rel="shortcut icon" type="image/x-icon" href="images/logo.png" />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n\n.containerr {\n    width: 90%;\n    margin: 0 auto;\n    padding-top: 50px;\n}\n\n.main-heading {\n    font-size: 2.5rem;\n    font-weight: bold;\n    color: red;\n    text-align: left;\n    margin-bottom: 20px;\n}\n\n.intro-text {\n    font-size: 1.2rem;\n    margin-bottom: 40px;\n    color: #555;\n}\n\n.cards-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.card {\n    background-color: white;\n    padding: 20px;\n    width: 30%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    text-align: center;\n}\n\n.card-heading {\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: red;\n    margin-bottom: 15px;\n}\n\n.card-text {\n    font-size: 1rem;\n    color: #555;\n}\n\n@media (max-width: 768px) {\n    .cards-container {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .card {\n        width: 90%;\n        margin-bottom: 20px;\n    }\n}\n\n"
          }}
        />
        {/*[if lt IE 8]>
  <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.</p>
    <![endif]*/}
        <Header />
        <div id="popup-search-box">
          <div className="box-inner-wrap d-flex align-items-center">
            <form id="form" action="#" method="get" role="search">
              <input
                id="popup-search"
                type="text"
                name="s"
                placeholder="Type keywords here..."
              />
              <button id="popup-search-button" type="submit" name="submit">
                <i className="fa-sharp fa-light fa-magnifying-glass" />
              </button>
            </form>
            <div className="search-close">
              <i className="fa-regular fa-xmark" />
            </div>
          </div>
        </div>
        {/*/.popupsearch-box*/}
        <div id="searchbox-overlay" />
        <section className="page-header">
          <div className="container">
            <div className="page-header-info">
              <h4>Your Load Our Commitment</h4>
              <h2>
                Resources
              </h2>
              <p>
      
              </p>
            </div>
          </div>
        </section>
        {/*page-header*/}
<section className="resources-section">
    <div className="container">
        <div className="row">
            <div className="col-lg-4 col-md-6">
                <div className="resource-card">
                    <a href="https://apply.srtranspor.com/apply/otrdriver">
                        <div className="resource-card-image">
                            Add driver information
                        </div>
                    </a>
                </div>
            </div>
            <div className="col-lg-4 col-md-6">
                <div className="resource-card">
                    <a href="https://apply.srtranspor.com/apply/owneroperator">
                        <div className="resource-card-image">
                            Add owner operator information
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>


        <footer className="footer-section">
          <div className="map-pattern" />
          <div className="footer-wrapper">
            <div className="container">
              <div className="row gy-lg-0 gy-4">
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget">
                    <Link to="/" className="footer-logo">
                      <img src="images/logo.png" alt="logo" />
                    </Link>
                    <p>
                      Safe and Reliable Transportation specializes in efficient
                      transport warehousing and distribution of goods.
                    </p>
                    <ul className="social-share">
                      <li>
                        <a href="https://www.facebook.com/profile.php?id=61575268596055">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                      </li>
                    ®
                  
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget widget-links">
                    <div className="widget-title">
                      <h3>Company</h3>
                    </div>
                    <ul className="footer-links">
                      <li>
                        <Link to="/aboutus">About Us</Link>
                      </li>
                      <li>
                        <Link to="/services">Our Services</Link>
                      </li>
                      <li>
                        <Link to="/testimonials">Testimonials</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                      <li>
                        <a href="https://apply.srtranspor.com/login/driver">Driver Login</a>
                      </li>
                      <li>
                        <a href="https://apply.srtranspor.com/login/company">Customer Login</a>
                      </li>
                      <li>
                        <Link to="/resources">Resources</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget">
                    <div className="widget-title">
                      <h3>Get In Touch</h3>
                    </div>
                    <ul className="footer-contact-info">
                      <li>
                        <p>
                          <span>Address:</span>9528 Baltimore, Ave
                          Laurel, MD 20723
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>Mail Us:</span>humanresource@srtranspor.com
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="footer-widget">
                    <div className="widget-title">
                      <h3>Newslatter Signup</h3>
                    </div>
                    <form action="#" className="subscribe-form" noValidate="true">
                      <div className="mc-fields">
                        <input
                          className="form-control"
                          type="email"
                          name="EMAIL"
                          placeholder="Your Email"
                          required=""
                        />
                        <input
                          type="hidden"
                          name="action"
                          defaultValue="mailchimpsubscribe"
                        />
                        <button className="submit">
                          <i className="fa-regular fa-arrow-right-long" />
                        </button>
                      </div>
                      <div className="clearfix" />
                      <div id="subscribe-result">
                        <div className="subscription-success" />
                        <div className="subscription-error" />
                      </div>
                    </form>
                    <p className="mt-20">
                      Subscribe us and get all the benifits from today.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="running-truck">
              <div className="truck" />
              <div className="truck-2" />
              <div className="truck-3" />
            </div>
          </div>
          <div className="copyright-area">
            <span id="currentYear"> </span> © Safe and Reliable Transportation ,
            All Rights Reserved.
          </div>
        </footer>
        {/*/.footer-section*/}
        <div id="scrollup">
          <button id="scroll-top" className="scroll-to-top">
            <i className="fa-regular fa-arrow-up" />
          </button>
        </div>
        {/*/.scrollup*/}
        {/* Mirrored from html.dynamiclayers.net/te/logisko/services-logistic.html by HTTrack Website Copier/3.x [XR&CO'2014], Thu, 05 Dec 2024 18:04:20 GMT */}
      </>

    </div>
  )
}

export default Resources